export default __webpack_public_path__ + "static/media/RLC.ae1e20c5.png";